import { render, staticRenderFns } from "./EditSchool.vue?vue&type=template&id=f1a72ecc&"
import script from "./EditSchool.vue?vue&type=script&lang=js&"
export * from "./EditSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports